module.exports = __webpack_public_path__ + "static/mielona czarka@0,5x-5b00a95baa854018bdf467528fb8d997.png";